function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M354.73,175.08a1,1,0,0,1-1-1,46.94,46.94,0,0,0-25.3-41.73,1,1,0,0,1-.41-1.29,1,1,0,0,1,1.3-.41,48.88,48.88,0,0,1,26.33,43.43A1,1,0,0,1,354.73,175.08Z",
  transform: "translate(-247.66 -113.56)"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "111.36 56.15 107.07 66.84 102.79 56.15 111.36 56.15"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M252.68,175.08a1,1,0,0,1-1-1,48.87,48.87,0,0,1,26.32-43.43,1,1,0,0,1,1.3.41,1,1,0,0,1-.41,1.29,46.94,46.94,0,0,0-25.3,41.73A1,1,0,0,1,252.68,175.08Z",
  transform: "translate(-247.66 -113.56)"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  points: "0.74 56.15 5.03 66.84 9.31 56.15 0.74 56.15"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M290.18,117.46v4h4.22l-3.12,3.12h-2.35a1.87,1.87,0,0,1-1.87-1.87v-5.23h3.12m11.38,0v7.06h-3.12v-1.44l-.3.29L297,124.56h-4.43l3.65-3.64.3-.3H291.3l3.09-3.12h7.17",
  transform: "translate(-247.66 -113.56)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M319.15,113.56a1.88,1.88,0,0,1,1.88,1.87v1.25H310l3.11-3.12h6m-7.4,0-3.66,3.66-.29.29H317v2.19l-4.86,4.86h-4.43l3.18-3.18.46-.46.29-.29h-9.13v-2.2l4.85-4.87h4.43m-2.4,8-3,3h-3.93v-3h6.89",
  transform: "translate(-247.66 -113.56)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M321,117.45v5.24a1.88,1.88,0,0,1-1.88,1.87h-1.26v-7.11H321",
  transform: "translate(-247.66 -113.56)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M305.9,113.56l-3.07,3.12H287.06v-1.25a1.87,1.87,0,0,1,1.87-1.87h17",
  transform: "translate(-247.66 -113.56)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M356,186.57a4.94,4.94,0,1,0,4.1,4.1A4.94,4.94,0,0,0,356,186.57Zm1.87,5.79h-1.74v2.08h-1.81v-2.09h-1.75v-1.79h1.74v-2.08h1.81v2.08h1.74Z",
  transform: "translate(-247.66 -113.56)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M253.6,186.57a4.94,4.94,0,1,0,4.1,4.1A4.94,4.94,0,0,0,253.6,186.57Zm1.87,4v1.79l-5.29,0v-1.79Z",
  transform: "translate(-247.66 -113.56)"
});

function SvgRotaryDir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 112.47 82.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotaryDir);
export default __webpack_public_path__ + "static/media/rotary-dir.8c89b121.svg";
export { ForwardRef as ReactComponent };